// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","QualityCheckboxes":"ex_a bhn_j bhn_i bhn_bc bhn_r bhn_st","QualityCheckboxes__quality":"ex_b"};